import { IdDescriptionDto } from '@app/data/dtos/shared/id-description.dto';
import { IdNameDto } from '@app/data/dtos/shared/id-name.dto';
import { IdDescription } from '@app/entities/interfaces/data/iddescription.interface';
import { IdName } from '@app/entities/interfaces/data/idname.interface';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapIdName: MapFromFn<IdNameDto, IdName> = (value) =>
  Builder.forModel(IdName).id(value.id).name(value.name).build();

export const mapIdDescripcion: MapFromFn<IdDescriptionDto, IdDescription> = (value) =>
  Builder.forModel(IdDescription).id(value.id).description(value.description).build();
